import "./Experience.css";
import { useTheme } from "@chakra-ui/react";
import {
    VerticalTimeline,
    VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { MdWork } from "react-icons/md";
import { FaGraduationCap } from "react-icons/fa";

const Experience = () => {
    const theme = useTheme();
    return (
        <div
            className="experience"
            id="experience"
            style={{
                color: theme.colors.secondary,
            }}
        >
            <h1 className="sectionHeading">Experience</h1>

            <VerticalTimeline>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{
                        background: theme.colors.secondary,
                        color: theme.colors.primary,
                    }}
                    contentArrowStyle={{
                        borderRight: "7px solid  #BFDBF7",
                    }}
                    date="2024 - present"
                    iconStyle={{
                        background: theme.colors.tertiary,
                        color: "white",
                    }}
                    icon={<MdWork />}
                >
                    <h3 className="vertical-timeline-element-title role">
                        Education Partnerships Manager
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle company">
                        RMIT Europe, Barcelona, Spain
                    </h4>
                    <p className="roleDescription">
                        Manager of industry and education partnerships for the
                        development of global student experiences and education
                        delivery out of RMIT University's innovation hub in
                        Europe.
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{
                        background: theme.colors.secondary,
                        color: theme.colors.primary,
                    }}
                    contentArrowStyle={{
                        borderRight: "7px solid  #BFDBF7",
                    }}
                    date="2022 - 2023"
                    iconStyle={{
                        background: theme.colors.tertiary,
                        color: "white",
                    }}
                    icon={<MdWork />}
                >
                    <h3 className="vertical-timeline-element-title role">
                        Junior Software Developer
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle company">
                        Fergus, Auckland, New Zealand
                    </h4>
                    <p className="roleDescription">
                        React Native, Typescript and GraphQL developer for the
                        Fergus trades job management mobile app. Implemented new
                        design system in the company's component library for
                        internship project.
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{
                        background: theme.colors.secondary,
                        color: theme.colors.primary,
                    }}
                    contentArrowStyle={{
                        borderRight: "7px solid  #BFDBF7",
                    }}
                    date="2022"
                    iconStyle={{
                        background: theme.colors.tertiary,
                        color: "white",
                    }}
                    icon={<FaGraduationCap />}
                >
                    <h3 className="vertical-timeline-element-title role">
                        Student - Diploma in Web Development and Design
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle company">
                        Developers Institute, New Zealand
                    </h4>
                    <p className="roleDescription">
                        Diploma covering client-side, server-side, full-stack,
                        agile development and DevOps
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2018 - 2021"
                    iconStyle={{
                        background: theme.colors.tertiary,
                        color: "white",
                    }}
                    contentStyle={{
                        background: theme.colors.secondary,
                        color: theme.colors.primary,
                    }}
                    contentArrowStyle={{
                        borderRight: "7px solid  #BFDBF7",
                    }}
                    icon={<MdWork />}
                >
                    <h3 className="vertical-timeline-element-title role">
                        Regional Coordinator, Americas, Europe and Africa
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle company">
                        RMIT Europe, Barcelona, Spain
                    </h4>
                    <p className="roleDescription">
                        Developed strategic plans for the recruitment of over
                        500 international students annually, and the management
                        of over 100 education agencies, university partnerships
                        and sponsorship bodies.
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2008 - 2010"
                    iconStyle={{
                        background: theme.colors.tertiary,
                        color: "white",
                    }}
                    contentStyle={{
                        background: theme.colors.secondary,
                        color: theme.colors.primary,
                    }}
                    contentArrowStyle={{
                        borderRight: "7px solid  #BFDBF7",
                    }}
                    icon={<MdWork />}
                >
                    <h3 className="vertical-timeline-element-title role">
                        Global Mobility Advisor
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle company">
                        RMIT University, Melbourne, Australia
                    </h4>
                    <p className="roleDescription">
                        Managed the study abroad application management system,
                        TerraDotta and attended the TerraDotta conference in the
                        USA. Chairman of the Homecoming Forum for all
                        universities in Melbourne.
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2010 - 2011"
                    iconStyle={{
                        background: theme.colors.tertiary,
                        color: "white",
                    }}
                    contentStyle={{
                        background: theme.colors.secondary,
                        color: theme.colors.primary,
                    }}
                    contentArrowStyle={{
                        borderRight: "7px solid  #BFDBF7",
                    }}
                    icon={<MdWork />}
                >
                    <h3 className="vertical-timeline-element-title role">
                        Assistant Country Manager and Project Manager
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle company">
                        Projects Abroad, Peru
                    </h4>
                    <p className="roleDescription">
                        Directed induction and in-country support for over 400
                        volunteers. Managed the relationships with the Peruvian
                        host families and coordinated events with volunteer
                        placement institutions.
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="2008"
                    iconStyle={{
                        background: theme.colors.tertiary,
                        color: "white",
                    }}
                    contentStyle={{
                        background: theme.colors.secondary,
                        color: theme.colors.primary,
                    }}
                    contentArrowStyle={{
                        borderRight: "7px solid  #BFDBF7",
                    }}
                    icon={<FaGraduationCap />}
                >
                    <h3 className="vertical-timeline-element-title role">
                        Student - Postgraduate Diploma in Translation Studies
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle company">
                        University of Auckland, New Zealand
                    </h4>
                    <p className="roleDescription">
                        Honours A+. <br />
                        Translated a novel from Italian to English
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="2007"
                    iconStyle={{
                        background: theme.colors.tertiary,
                        color: "white",
                    }}
                    contentStyle={{
                        background: theme.colors.secondary,
                        color: theme.colors.primary,
                    }}
                    contentArrowStyle={{
                        borderRight: "7px solid  #BFDBF7",
                    }}
                    icon={<FaGraduationCap />}
                >
                    <h3 className="vertical-timeline-element-title role">
                        Student - Bachelor of Arts
                    </h3>
                    <h4 className="vertical-timeline-element-subtitle company">
                        University of Auckland, New Zealand
                    </h4>
                    <p className="roleDescription">
                        Major in Spanish language. <br />
                        Annual prize in Arts. <br />
                        Study Abroad Languages and Literatures Scholarship
                    </p>
                </VerticalTimelineElement>
            </VerticalTimeline>
        </div>
    );
};

export default Experience;
